import { Component, OnInit, inject, viewChild } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatDialog } from '@angular/material/dialog';
import { ColumnMode, SortType } from '@swimlane/ngx-datatable';
import { ConsumptionFilterStrategy, IConsumptionFilterStrategy, MatchAlgorithm } from 'src/app/api/api-campaigns.service.generated';
import { GUID } from 'src/app/common/utils/GuidUtils';
import { FuzzyTestComponent } from '../fuzzy-test/fuzzy-test.component';
import { ButtonComponent } from "wecheer-common";

export interface IExtendedConsumptionFilterStrategy extends IConsumptionFilterStrategy {
  visible?: boolean | undefined;
  guid?: string;
}

@Component({
  selector: 'app-consumption-filters-edit',
  templateUrl: './consumption-filters-edit.component.html',
  styleUrls: ['./consumption-filters-edit.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    FlexLayoutModule,
    NgxDatatableModule,
    ButtonComponent
  ]
})

export class ConsumptionFiltersEditComponent implements OnInit {
  private dialog = inject(MatDialog);


  public readonly form = viewChild<NgForm>('form');
  readonly datatable = viewChild<any>('datatable');
  matchAlgorithms: { id: string, text: string }[];
  ColumnMode = ColumnMode;
  SortType = SortType;
  consumptionFilters: IExtendedConsumptionFilterStrategy[];

  searchTerm: string;
  searchCount: number;
  toggle = true;

  ngOnInit() {
    this.bindMatchAlgorithms();
    if (!this.consumptionFilters)
      this.consumptionFilters = [];
  }

  bindMatchAlgorithms() {
    let algorithms = [];
    for (let value in MatchAlgorithm)
      algorithms.push({ id: value, text: value });
    this.matchAlgorithms = algorithms;
  }

  setFormValue(filters: ConsumptionFilterStrategy[]) {
    // add empty consumption filter item
    if (!filters || filters.length === 0) return;
    //filters = [ new ConsumptionFilterStrategy({}) ];

    // generate fake id
    let extendedFilters: IExtendedConsumptionFilterStrategy[] = filters;
    extendedFilters.forEach(ef => {
      ef.guid = this.generateNewId();
      ef.visible = true;
    });

    this.consumptionFilters = extendedFilters;
  }
  getFormValue(): ConsumptionFilterStrategy[] {
    const consumptionFilterStrategies = this.consumptionFilters.map(cf => new ConsumptionFilterStrategy(cf));
    return consumptionFilterStrategies;
  }

  isValid() {
    this.resetSearch();

    const isValid = this.form().valid;
    if (!isValid)
      this.forceValidatorsToDisplayErrors();

    return isValid;
  }

  forceValidatorsToDisplayErrors() {
    // force validators to display errors
    this.form().control.markAsTouched();
    this.form().control.markAsDirty();

    Object.keys(this.form().control.controls).forEach(key => {
      this.form().control.get(key).markAsTouched();
      this.form().control.get(key).markAsDirty();
    });
  }

  generateNewId(): string {
    return GUID.newGuid().replace(/-/g, '');
  }

  addConsumptionFilter() {
    let extendedFilter: IExtendedConsumptionFilterStrategy = {
      wildCard: null,
      guid: this.generateNewId()
    };
    this.consumptionFilters.unshift(extendedFilter);
    this.applySearch();
    this.consumptionFilters = [...this.consumptionFilters];
  }

  removeConsumptionFilter(guid: string) {
    let consumptionFilterToRemove = this.consumptionFilters.find(cf => cf.guid === guid);
    let consumptionFilterToRemoveIndex = this.consumptionFilters.indexOf(consumptionFilterToRemove);
    this.consumptionFilters.splice(consumptionFilterToRemoveIndex, 1);
    this.applySearch();
    this.consumptionFilters = [...this.consumptionFilters];
  }

  searchConsumptionFilter() {
    this.applySearch();
    this.consumptionFilters = [...this.consumptionFilters];
  }

  applySearch() {
    this.consumptionFilters.forEach(cf => {
      if (this.searchTerm) {
        if (cf.wildCard) {
          cf.visible = cf.wildCard.toLowerCase().includes(this.searchTerm.toLowerCase());
        }
        else {
          cf.visible = false;
        }
      }
      else
        cf.visible = true;
    });
    this.searchCount = this.searchTerm ? this.consumptionFilters.filter(cf => cf.visible).length : undefined;
  }

  async resetSearch() {
    this.searchTerm = undefined;
    this.applySearch();
    this.consumptionFilters = [...this.consumptionFilters];
  }

  async testFuzzy() {
    await FuzzyTestComponent.open(this.dialog);
  }

  onSort() {
    // const arr = [...this.consumptionFilters];
    // this.consumptionFilters = [];
    this.toggle = false;
    setTimeout(() => {
      this.toggle = true;
      // this.consumptionFilters = arr;
    });
  }
  onInput(ev: any, row: any, prop: string) {
    if (ev.target.value) {
      row[prop] = ev.target.value;
    }
  }
}

